<section *ngIf="data.success && !data.tabs[0].error" class="fee-data">
	<section class="row" *ngFor="let attributes of data.tabs[0].tableData[0].headersX; index as i">
		<ng-container *ngIf="attributes.config && attributes.config.visible">
			<section class="col-8">
				<span>{{ attributes.formattedValue }}</span>
				<icon
					*ngIf="attributes.config && attributes.config.infoBubble"
					type="info-circle"
					class="info-circle"
					[tooltip]="infoBubble"
					[analytic-data]="{ linkName: 'tooltip_' + attributes.formattedValue }"
				></icon>
				<ng-template #infoBubble> <section [innerHTML]="attributes.attribute.infoBubble"></section> </ng-template>
				<dcr-cell-content [cell]="attributes"></dcr-cell-content>
			</section>
			<section class="col-16">{{ tableData.cells[selectedPortfolioIndex][i].formattedValue }}</section>
		</ng-container>
	</section>
</section>
